import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import { AnalyticsConsent } from './components/AnalyticsConsent';
import './styles.css';

const root = document.getElementById('root')!;
const app = (
  <StrictMode>
    <App />
    <AnalyticsConsent />
  </StrictMode>
);

if (root.hasChildNodes()) {
  hydrateRoot(root, app);
} else {
  createRoot(root).render(app);
}
